// tslint:disable:trailing-comma
export enum Container {
  Neo = 'neo',
  Titans = 'titans',
  Others = 'others',
}

export enum NeoNamespace {
  CoreNeo = 'core/neo',
  CoreParamsTunnel = 'core/params-tunnel',
  CorePrefetchDataTunnel = 'core/prefetch-data-tunnel',
  UtilCheckObjectKeys = 'util/check-object-keys',
  UtilControlFlow = 'util/control-flow',
  UtilStorage = 'util/storage',
  UtilNeoError = 'util/neo-error',
  UtilDebug = 'util/debug',
  UtilMock = 'util/mock',
  Stat = 'stat/index',
  StatLXAnalyticsChannel = 'stat/channel/lxanalytics-channel',
  StatRaptorChannel = 'stat/channel/raptor-channel',
  StatMetricChannel = 'stat/channel/metric-channel',
  StatHelper = 'stat/neo-stat-helper',
  Bridge = 'bridge/index',
  BridgeExecute = 'bridge/execute-bridge',
  Undefined = 'undefined',
}
